import * as React from 'react';

const useDropdown = (initialIsOpen = true, onChangeCallback?: (isOpen: boolean) => void) => {
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(initialIsOpen);

  const handleChange = React.useCallback((): void => {
    setIsDropdownOpen((oldIsDropdownOpen) => {
      const newIsOpen = !oldIsDropdownOpen;
      if (onChangeCallback) {
        onChangeCallback(newIsOpen);
      }
      return newIsOpen;
    });
  }, [onChangeCallback]);

  React.useEffect(() => {
    setIsDropdownOpen(initialIsOpen);
  }, [initialIsOpen]);

  return { isDropdownOpen, handleChange };
};

export default useDropdown;
